<mat-toolbar class="app-toolbar">
  <mat-menu #orderMenu="matMenu">
    <!-- shop=1/shop=2 to te same ID co salesChannels.id "Hurt Polski"/"Hurt
         Zagraniczny" (patrz WHOLESALE_PL_SHOP_ID/WHOLESALE_FOREIGN_SHOP_ID w
         orders-list.component.ts) - maja wiec gotowe wezly channel-access.1/
         channel-access.2 (patrz plan pkt 3). -->
    <a mat-menu-item [routerLink]="['/orders/list', '1', '1']" *appHasPermission="'channel-access.1'">
      {{ 'MENU.ORDERS.WHOLESALE_PL' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/orders/list', '2', '2']" *appHasPermission="'channel-access.2'">
      {{ 'MENU.ORDERS.WHOLESALE_FOREIGN' | translate }}
    </a>
    <!-- Bez dostepu do zadnego kanalu detalicznego saleChannels jest puste
         (patrz getSaleChannels()) - ukrywamy tez trigger, zeby nie pokazywac
         przycisku otwierajacego pusty dropdown (ten sam wzorzec co
         *appHasPermission na przyciskach-kontenerach nizej). -->
    <a mat-menu-item [routerLink]="['/orders/list', '3']" [matMenuTriggerFor]="subOrdersMenu" *ngIf="saleChannels.length > 0">
      {{ 'MENU.ORDERS.RETAIL' | translate }}
    </a>
  </mat-menu>

  <mat-menu #subOrdersMenu="matMenu">
    <a
      *ngFor="let channel of saleChannels"
      mat-menu-item
      [routerLink]="['/orders/list', '3', channel.id]"
    >
      {{ channel.name }}
    </a>
  </mat-menu>

  <mat-menu #invoicesMenu="matMenu">
    <a mat-menu-item [routerLink]="['/invoices/list']">
      {{ 'MENU.INVOICES.ALL' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/invoices/list', 'pro']">
      {{ 'MENU.INVOICES.PROFORMAS' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/invoices/list', 'vat']">
      {{ 'MENU.INVOICES.VAT' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/invoices/list', 'kor']">
      {{ 'MENU.INVOICES.CORRECTIONS' | translate }}
    </a>
  </mat-menu>

  <mat-menu #docMenu="matMenu">
    <a mat-menu-item [matMenuTriggerFor]="orderMenu" [routerLink]="['/orders/list']" *appHasPermission="'orders'">
      {{ 'MENU.DOCUMENTS.ORDERS' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/orders/control']" *appHasPermission="'orders.control'">
      {{ 'MENU.DOCUMENTS.ORDER_CONTROL' | translate }}
    </a>
    <a mat-menu-item [matMenuTriggerFor]="invoicesMenu" [routerLink]="['/invoices/list']" *appHasPermission="'invoices'">
      {{ 'MENU.DOCUMENTS.INVOICES' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/zestawienia']" *appHasPermission="'reports'">
      {{ 'MENU.DOCUMENTS.REPORTS' | translate }}
    </a>
    <a mat-menu-item [matMenuTriggerFor]="exportsMenu" [routerLink]="['/eksporty/faktury-xml']" *appHasPermission="'exports'">
      {{ 'MENU.DOCUMENTS.EXPORTS' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/stock-requests/list']" *appHasPermission="'documents.stock-requests'">
      {{ 'MENU.DOCUMENTS.STOCK_REQUESTS' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/faktury-kosztowe']" *appHasPermission="'documents.cost-invoices'">
      {{ 'MENU.DOCUMENTS.COST_INVOICES' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/numery-seryjne']" *appHasPermission="'documents.serial-numbers'">
      {{ 'MENU.DOCUMENTS.SERIAL_NUMBERS' | translate }}
    </a>
    <!-- dla wszystkich zalogowanych (14.10.2026), zawezenie po kanalach robi backend -->
    <a mat-menu-item [routerLink]="['/szukaj-po-trackingu']">
      {{ 'MENU.DOCUMENTS.TRACKING_SEARCH' | translate }}
    </a>
  </mat-menu>

  <mat-menu #prodMenu="matMenu">
    <a mat-menu-item [routerLink]="['/produkty/list']" *appHasPermission="'products.catalog'">
      {{ 'MENU.PRODUCTS.PRODUCTS' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/shipping/import']" *appHasPermission="'products.shipping.import'; level: 'write'">
      {{ 'MENU.PRODUCTS.SHIPPING_IMPORT' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/shipping']" *appHasPermission="'products.shipping'">
      {{ 'MENU.PRODUCTS.DELIVERIES' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/product-price-lists/list']" *appHasPermission="'products.price-lists'">
      {{ 'MENU.PRODUCTS.PRICE_LISTS' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/produkty/dzialania-masowe']" *appHasPermission="'products.bulk'; level: 'write'">
      {{ 'MENU.PRODUCTS.BULK' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/produkty/kategorie']" *appHasPermission="'products.categories'">
      {{ 'MENU.PRODUCTS.CATEGORIES' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/produkty/marki']" *appHasPermission="'products.brands'">
      {{ 'MENU.PRODUCTS.BRANDS' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/produkty/bom']" *appHasPermission="'products.bom'">
      {{ 'MENU.PRODUCTS.BOM' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/produkty/flagi']" *appHasPermission="'products.flags'">
      {{ 'MENU.PRODUCTS.FLAGS' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/produkty/do-sprawdzenia']" *appHasPermission="'products.review'">
      {{ 'MENU.PRODUCTS.REVIEW' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/produkty/ean']" *appHasPermission="'products.ean'">
      {{ 'MENU.PRODUCTS.EAN' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/produkty/zdjecia']" *appHasPermission="'products.photos'; level: 'write'">
      {{ 'MENU.PRODUCTS.PHOTOS' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/produkty/szrot']" *appHasPermission="'products.scrap'">
      {{ 'MENU.PRODUCTS.SCRAP' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/produkty/paczki-sklepowe']" *appHasPermission="'products.shop-packages'; level: 'write'">
      {{ 'MENU.PRODUCTS.SHOP_PACKAGES' | translate }}
    </a>
  </mat-menu>

  <mat-menu #wholesellersMenu="matMenu">
    <a mat-menu-item [routerLink]="['/wholesaler/list']" *appHasPermission="'clients.wholesalers'">
      {{ 'MENU.CLIENTS.WHOLESALERS' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/deposits']" *appHasPermission="'clients.deposits'">
      {{ 'MENU.CLIENTS.DEPOSITS' | translate }}
    </a>
  </mat-menu>

  <mat-menu #localSettingsMenu="matMenu">
    <div class="local-settings-header">
      {{ 'MENU.LOCAL_SETTINGS.TITLE' | translate }}
    </div>
    <mat-divider></mat-divider>
    <div class="local-settings-theme" (click)="$event.stopPropagation()">
      <mat-form-field appearance="outline" class="theme-select">
        <mat-label>{{ 'MENU.THEME.TITLE' | translate }}</mat-label>
        <mat-select [value]="currentTheme" (selectionChange)="changeTheme($event.value)">
          <mat-option *ngFor="let t of themes" [value]="t.id">
            {{ t.labelKey | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-divider></mat-divider>
    <div class="local-settings-sound" (click)="$event.stopPropagation()">
      <mat-checkbox [ngModel]="soundEnabled$ | async" (ngModelChange)="toggleSound($event)">
        {{ 'MENU.LOCAL_SETTINGS.CHAT_SOUND' | translate }}
      </mat-checkbox>
    </div>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="changePrinterIp()">
      <mat-icon>print</mat-icon>
      <span>{{ 'MENU.LOCAL_SETTINGS.PRINTER_IP' | translate }}</span>
    </button>
  </mat-menu>

  <mat-menu #adminMenu="matMenu">
    <a mat-menu-item [routerLink]="['/profile']" *appHasPermission="'admin.profiles'">
      {{ 'MENU.ADMIN.PROFILES' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/profile/kto-ma-dostep']" *appHasPermission="'admin.profiles'">
      {{ 'MENU.ADMIN.WHO_HAS_ACCESS' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/ustawienia']" *appHasPermission="'admin.settings'">
      {{ 'MENU.ADMIN.SETTINGS' | translate }}
    </a>
  </mat-menu>

  <mat-menu #exportsMenu="matMenu">
    <a mat-menu-item [routerLink]="['/eksporty/faktury-xml']">
      {{ 'MENU.DOCUMENTS.EXPORTS_INVOICES_XML' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/eksporty/faktury-xml-delta']">
      {{ 'MENU.DOCUMENTS.EXPORTS_INVOICES_XML_DELTA' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/eksporty/koszty-xml-delta']">
      {{ 'MENU.DOCUMENTS.EXPORTS_COSTS_XML_DELTA' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/eksporty/faktury-txt']">
      {{ 'MENU.DOCUMENTS.EXPORTS_INVOICES_TXT' | translate }}
    </a>
  </mat-menu>

  <mat-menu #localServicesMenu="matMenu">
    <a mat-menu-item [routerLink]="['/local-services']" *appHasPermission="'local-services.contracts'">
      {{ 'MENU.LOCAL_SERVICES_MENU.CONTRACTS' | translate }}
    </a>
    <a mat-menu-item [routerLink]="['/local-services/movements']" *appHasPermission="'local-services.movements'">
      {{ 'MENU.LOCAL_SERVICES_MENU.MOVEMENTS' | translate }}
    </a>
  </mat-menu>

  <div class="nav-links">
    <a
      mat-button
      class="nav-link"
      [routerLink]="['/']"
      routerLinkActive="nav-link-active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      {{ 'MENU.MAIN.HOME' | translate }}
    </a>
    <a
      mat-button
      class="nav-link changelog-link"
      [routerLink]="['/dziennik-zmian']"
      routerLinkActive="nav-link-active"
    >
      {{ 'MENU.MAIN.CHANGELOG' | translate }}
      <span class="changelog-dot" *ngIf="hasUnseenChanges$ | async"></span>
    </a>
    <a mat-button class="nav-link" *appHasPermission="'leaves'" [routerLink]="['/urlopy']" routerLinkActive="nav-link-active">
      {{ 'MENU.MAIN.HOLIDAYS' | translate }}
    </a>
    <ng-container *ngIf="statsAllowed">
      <a
        mat-button
        class="nav-link"
        [routerLink]="['/statystyki']"
        routerLinkActive="nav-link-active"
        *appHasPermission="'statistics'"
      >
        {{ 'MENU.MAIN.STATISTICS' | translate }}
      </a>
    </ng-container>
    <a
      mat-button
      class="nav-link"
      [routerLink]="['/magazyn-marketingowy']"
      [class.nav-link-active]="isSectionActive(['magazyn-marketingowy'])"
      *appHasPermission="'marketing'"
    >
      {{ 'MENU.MAIN.MARKETING_WAREHOUSE' | translate }}
    </a>
    <a
      mat-button
      class="nav-link"
      [routerLink]="['/sklepy-i-kanaly']"
      [class.nav-link-active]="isSectionActive(['sklepy-i-kanaly'])"
      *appHasPermission="['channels.overview', 'channels.react', 'channels.compare']"
    >
      {{ 'MENU.MAIN.CHANNELS' | translate }}
    </a>
    <button
      mat-button
      class="nav-link"
      [class.nav-link-active]="isSectionActive(['orders', 'invoices', 'eksporty', 'stock-requests', 'numery-seryjne', 'faktury-kosztowe', 'szukaj-po-trackingu'])"
      [matMenuTriggerFor]="docMenu"
    >
      {{ 'MENU.MAIN.DOCUMENTS' | translate }}
    </button>
    <button
      mat-button
      class="nav-link"
      [class.nav-link-active]="isSectionActive(['produkty', 'shipping', 'product-price-lists'])"
      [matMenuTriggerFor]="prodMenu"
      *appHasPermission="['products.catalog', 'products.shipping', 'products.price-lists']"
    >
      {{ 'MENU.MAIN.PRODUCT_BASE' | translate }}
    </button>
    <button
      mat-button
      class="nav-link"
      [class.nav-link-active]="isSectionActive(['wholesaler', 'deposits'])"
      [matMenuTriggerFor]="wholesellersMenu"
      *appHasPermission="['clients.wholesalers', 'clients.deposits']"
    >
      {{ 'MENU.MAIN.CLIENT_BASE' | translate }}
    </button>
    <button
      mat-button
      class="nav-link"
      [class.nav-link-active]="isSectionActive(['local-services'])"
      [matMenuTriggerFor]="localServicesMenu"
      *appHasPermission="['local-services.contracts', 'local-services.movements']"
    >
      {{ 'MENU.MAIN.LOCAL_SERVICES' | translate }}
    </button>
    <button
      mat-button
      class="nav-link"
      [class.nav-link-active]="isSectionActive(['profile', 'ustawienia'])"
      [matMenuTriggerFor]="adminMenu"
      *appHasPermission="['admin.profiles', 'admin.settings']"
    >
      {{ 'MENU.MAIN.ADMIN' | translate }}
    </button>
  </div>

  <span class="spacer"></span>

  <button
    mat-button
    class="nav-link settings-btn"
    [matMenuTriggerFor]="localSettingsMenu"
  >
    <mat-icon>settings</mat-icon>
    <span>{{ 'MENU.LOCAL_SETTINGS.TITLE' | translate }}</span>
  </button>

  <!-- Wybor skorki celowo TYLKO w ustawieniach lokalnych (zebatka) -
       drugi select na belce dublowal funkcje (uwaga Patryka, 16.08). -->

  <mat-form-field appearance="standard" class="language-select">
    <mat-select
      [value]="currentLanguage"
      (selectionChange)="changeLanguage($event.value)"
    >
      <mat-select-trigger>{{ (currentLanguage || 'pl').toUpperCase() }}</mat-select-trigger>
      <mat-option value="pl">{{ 'LANGUAGE.PL' | translate }}</mat-option>
      <mat-option value="en">{{ 'LANGUAGE.EN' | translate }}</mat-option>
      <mat-option value="es">{{ 'LANGUAGE.ES' | translate }}</mat-option>
    </mat-select>
  </mat-form-field>

  <span class="user-name" *ngIf="logedUser">{{ logedUser.imie }} {{ logedUser.nazwisko }}</span>

  <button mat-button class="nav-link logout-btn" (click)="logout()">
    {{ 'MENU.MAIN.LOGOUT' | translate }}
  </button>
</mat-toolbar>

<app-breadcrumbs></app-breadcrumbs>
